import { t } from 'i18next';
interface HelpContent {
  [index: string]: {
    title: string;
    message: string;
    link: string;
    linkText: string;
  };
}

export default function InlineHelpContent(helpKey: string) {
  const InlineHelpMessage = t('Overview and support:');
  const INLINE_HELP_CONTENT: HelpContent = {
    // field types

    // You can add other control types here and the link will appear automatically on the template
    // editor, just set the key name as "field_type_<control_type_name>" with any spaces in the name
    // replaced by underscores. See controlTypesText.ts for the list of names.
    field_type_geolocation: {
      title: 'Geolocation',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713994609554-Field-Types-Geolocation-controls',
      linkText: t('Geolocation Controls'),
    },

    field_type_diagram: {
      title: 'Diagram',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713974612754-Field-Types-Diagram-controls',
      linkText: t('Diagram Controls'),
    },

    field_type_attachment: {
      title: 'Attachment',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25714046788882-Attach-Forms-Actions-Images-and-Files-Attachment-controls',
      linkText: t('Attachment Controls'),
    },

    // REGISTERS
    forms_register: {
      title: 'Forms',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713347845906-Records-and-Registers-Forms',
      linkText: t('Introduction to the Form register'),
    },
    // Should actually be an article called "Records and Registers: Memos" old link was https://support.apemobile.com/en/articles/1431229-records-and-registers-memos
    memos_register: {
      title: 'Memos',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713479756818-Using-Samm-Records-and-Registers-Memos',
      linkText: t('Introduction to the Memo register'),
    },
    actions_register: {
      title: 'Actions',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713590524306-Records-and-Registers-Actions-and-Punch-Lists',
      linkText: t('Introduction to the Action register'),
    },
    punch_lists_register: {
      title: 'Punch Lists',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713696401042-Using-Damstra-Forms-Punch-lists',
      linkText: t('Introduction to the Punch List register'),
    },
    drawings_register: {
      title: 'Drawings & Docs',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713671776018-Using-Damstra-Forms-Records-and-Registers-Drawings-Docs',
      linkText: t('Introduction to the Drawings and Docs register'),
    },

    // TEMPLATES
    templates: {
      title: 'Templates',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25711425978002-Making-Templates-Exercise-Creating-a-More-Advanced-Template',
      linkText: t('Managing Templates'),
    },
    // TEMPLATE EDITOR
    template_editor: {
      title: 'Template Editor',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/categories/30592663025042-Workforce-Forms?section_id=30593791834386&subsection_id=25710023320466',
      linkText: t('Template Creation Overview'),
    },
    template_editor_approvals: {
      title: 'Approval Section',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713946038930-Using-approvals-in-forms',
      linkText: t('Approval Section'),
    },
    formula: {
      title: 'Formula',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25714086976786-Using-Formulas-Formulas-in-forms-Introduction',
      linkText: t('Using Formulas in Forms'),
    },

    // MAIN SITE
    users: {
      title: 'Users',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713209034258-Organisation-Administration-Managing-Users',
      linkText: t('Managing Users'),
    },
    projects: {
      title: 'Projects',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713628672786-Project-Administration-Managing-Projects',
      linkText: t('Managing Projects'),
    },
    project_lists: {
      title: 'Project Lists',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713791165202-Project-Administration-Project-List-items',
      linkText: t('Project List Items'),
    },
    project_list_types: {
      title: 'Project List Types',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713377287826-Organisation-Administration-Managing-Project-List-Types',
      linkText: t('Project List Types'),
    },
    project_members: {
      title: 'Project Members',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713711366418-Project-Administration-Project-members',
      linkText: t('Managing Project Members'),
    },
    organisation_lists: {
      title: 'Organization Lists',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713278820498-Organisation-Administration-Managing-Organization-Lists',
      linkText: t('Managing Org Lists'),
    },
    organisation_settings: {
      title: 'Organization Settings',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25712984760082-Organisation-Administration-Organisation-Settings',
      linkText: t('Org Settings Overview'),
    },
    companies: {
      title: 'Companies',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713454631186-Organisation-Administration-Using-the-Companies-List',
      linkText: t('Managing Companies'),
    },
    drawings_import: {
      title: 'Import Drawings & Docs',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25714006413842-Exports-and-Imports-Importing-Drawings-and-Documents-in-Bulk',
      linkText: t('Importing Drawings and Documents'),
    },
    exports: {
      title: 'Exports',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713922296722-Exports-and-Imports-Exports-Overview',
      linkText: t('Exports'),
    },
    default_templates: {
      title: 'Default Templates',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25714109027346-Adding-Form-Templates-to-Projects',
      linkText: t('Adding templates to your Projects'),
    },
    custom_exports: {
      title: 'Custom Exports',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713934925330-Exports-and-Imports-Custom-Exports',
      linkText: t('Custom Export Help'),
    },
    wbs_items: {
      title: 'WBS Items',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713851773970-Project-Administration-WBS-Items',
      linkText: t('Managing WBS Items'),
    },
    sequence_numbers: {
      title: 'Sequence Numbers',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713873898514-Project-Administration-Sequence-Numbers',
      linkText: t('Sequence Numbers'),
    },
    properties: {
      title: 'Properties',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713859420946-Project-Administration-Project-Properties',
      linkText: t('Project Properties Overview'),
    },
    change_log: {
      title: 'Change Log',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713859420946-Project-Administration-Project-Properties',
      linkText: t('Change Log'),
    },
    reporting_project: {
      title: 'Reporting Project',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713919041938-Project-Administration-Reporting-Projects',
      linkText: t('What is a Reporting Project?'),
    },
    new_user: {
      title: 'Creating a new user',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713209034258-Organisation-Administration-Managing-Users',
      linkText: t('Creating a new user'),
    },
    edit_user: {
      title: 'Editing user details',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713209034258-Organisation-Administration-Managing-Users',
      linkText: t('Editing user details'),
    },
    identity_providers: {
      title: 'Identity Providers',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25711434673554-Ways-to-sign-in-Setting-up-SSO',
      linkText: t('Ways to sign in - Setting up SSO'),
    },
    approver_types: {
      title: 'Approver Types',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713557329938-Organisation-Administration-Approval-sections',
      linkText: t('Organisation Administration - Approval sections'),
    },

    //ALERTS
    alerts: {
      title: 'Alerts',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25711470689938-Insights-Getting-email-alerts',
      linkText: t('Managing Alerts'),
    },
    alerts_email_params: {
      title: 'Alerts',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25711470825234-Insights-Alert-email-parameters',
      linkText: t('Alert Email Parameters'),
    },

    // METRICS (formerly PROGRESS POINTS)
    metrics: {
      title: 'Metrics',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25711455344530-Insights-Setting-up-your-metrics',
      linkText: t('Managing Metrics'),
    },

    // GENERAL INTEGRATION
    integration_subdomain: {
      title: 'Choosing a Subdomain',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713865421074-Choose-your-Damstra-Forms-URL',
      linkText: t('Choosing a Subdomain'),
    },

    // PROCORE INTEGRATION
    procore_connector: {
      title: 'Procore Integration Overview',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/categories/30592663025042-Workforce-Forms?section_id=30593763949586&subsection_id=25710024357394',
      linkText: t('Procore Integration Overview'),
    },
    procore_trial_projects: {
      title: 'Selecting Projects',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/categories/30592663025042-Workforce-Forms?section_id=30593763949586&subsection_id=25710024357394',
      linkText: t('Selecting Projects'),
    },
    procore_trial_users: {
      title: 'Selecting Users',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/categories/30592663025042-Workforce-Forms?section_id=30593763949586&subsection_id=25710024357394',
      linkText: t('Selecting Users'),
    },
    procore_setup: {
      title: 'Procore Integration Setup',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/categories/30592663025042-Workforce-Forms?section_id=30593763949586&subsection_id=25710024357394',
      linkText: t('Procore Integration Setup'),
    },
    procore_projects: {
      title: 'Adding or Linking Projects from Procore',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/categories/30592663025042-Workforce-Forms?section_id=30593763949586&subsection_id=25710024357394',
      linkText: t('Adding or Linking Projects from Procore'),
    },
    procore_users: {
      title: 'Adding or Linking Users from Procore',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/categories/30592663025042-Workforce-Forms?section_id=30593763949586&subsection_id=25710024357394',
      linkText: t('Adding or Linking Users from Procore'),
    },
    procore_activation: {
      title: 'Activating your Procore Integration',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/categories/30592663025042-Workforce-Forms?section_id=30593763949586&subsection_id=25710024357394',
      linkText: t('Activating your Procore Integration'),
    },

    // BIM 360 INTEGRATION
    bim360_connector: {
      title: 'BIM 360 Integration Overview',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25711463612178-Get-connected-BIM-360-integration',
      linkText: t('BIM 360 Integration Overview'),
    },
    bim360_trial_projects: {
      title: 'Selecting Projects',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713922388498-Starting-a-trial-Connecting-a-BIM-360-Project',
      linkText: t('Selecting a project'),
    },
    bim360_trial_users: {
      title: 'Selecting Users',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713953898898-Starting-a-trial-Adding-BIM-360-users-to-Damstra-Forms',
      linkText: t('Selecting Users'),
    },
    bim360_setup: {
      title: 'BIM 360 Integration Setup',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713710977554-BIM-360-Integration-Setting-up-the-BIM-360-Integration',
      linkText: t('BIM 360 Integration Setup'),
    },
    bim360_activation: {
      title: 'Activating and Configuring your BIM 360 Integration',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713746376978-BIM-360-Integration-Activating-Your-BIM-360-Integration',
      linkText: t('Activating and Configuring your BIM 360 Integration'),
    },
    bim360_folder: {
      title: 'Specifying your BIM 360 Project Files Subfolder',
      message: InlineHelpMessage,
      link:
        'https://damstra.help.ideagen.com/hc/en-gb/articles/25713918128018-BIM-360-Integration-Specifying-your-BIM-360-Project-Files-Subfolder',
      linkText: t('Specifying your BIM 360 Project Files Subfolder'),
    },

    // BILLING
    billing: {
      title: '',
      message: '',
      link: '',
      linkText: '',
    },
    billing_users: {
      title: '',
      message: '',
      link: '',
      linkText: t('Total number of user licenses available'),
    },
    billing_addons: {
      title: '',
      message: '',
      link: '',
      linkText: t('Total number of Super Power addons'),
    },
    billing_external: {
      title: '',
      message: '',
      link: '',
      linkText: t('Total number of External User licenses available'),
    },
  };
  return INLINE_HELP_CONTENT[helpKey];
}
